export const CONNECTED_REQUEST_FILTER_KEY = 'connected_request'

export const RELATED_REQUESTS_TABLE_CONFIG_API =
  'idwell-api/api/v3/table/tables/request-related-requests/'

export const REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION = {
  attach: 'attach',
  deattach: 'deattach',
}

export const REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_FILTER_BAR_ITEMS_PROPS = {
  SaveTemplateButton: null,
  ShareTemplateButton: null,
}

export const REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_QA_NAME = {
  attach: 'requestProfileTabAttachedRequestsAttach',
  deattach: 'requestProfileTabAttachedRequestsDeattach',
  emptyAttach: 'requestProfileTabAttachedRequestsEmptyAttach',
  massEdit: 'requestProfileTabAttachedRequestsMassEdit',
}

export const REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_SUB_TAB_QA_NAME =
  'requestProfileTabAttachedRequestsSubTab'

export const REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_BUTTON_TEXT_KEY = {
  [REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION.attach]:
    'RequestProfile.RelatedRequestsAttachBtnKey',
  [REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION.deattach]:
    'RequestProfile.RelatedRequestsDeattachBtnKey',
  massEdit: 'RequestProfile.RelatedRequestsMassEditBtnKey',
}

export const REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_NOTIFICATION_TITLE_KEY = {
  [REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION.attach]:
    'RequestProfile.RelatedRequestsAttachSuccessKey',
  [REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION.deattach]:
    'RequestProfile.RelatedRequestsDeattachSuccessKey',
}

export const REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_DEATTACH_CONFIRMATION_KEY = {
  description:
    'RequestProfile.RelatedRequestsDeattachConfirmationDescriptionKey',
  submitText: 'RequestProfile.RelatedRequestsDeattachConfirmationSubmitBtnKey',
  title: 'RequestProfile.RelatedRequestsDeattachConfirmationTitleKey',
}

export const REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_REMOVE_ATTACH_CONFIRMATION_KEY =
  {
    description:
      'RequestProfile.RelatedRequestsRemoveConfirmationDescriptionKey',
    submitText: 'RequestProfile.RelatedRequestsRemoveConfirmationSubmitBtnKey',
    title: 'RequestProfile.RelatedRequestsRemoveConfirmationTitleKey',
  }

export const REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_REMOVE_ATTACH_MASS =
  'remove_from_related_mass'

export const REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_OPTION_LABEL_KEY = {
  archive: 'RequestProfile.RelatedRequestsArchiveOptionKey',
  editCategory: 'RequestProfile.RelatedRequestsEditCategoryOptionKey',
  editDeadline: 'RequestProfile.RelatedRequestsEditDeadlineOptionKey',
  editLabels: 'RequestProfile.RelatedRequestsEditLabelsOptionKey',
  editProviders: 'RequestProfile.RelatedRequestsEditProvidersOptionKey',
  editResponsibleManagers:
    'RequestProfile.RelatedRequestsEditResponsibleManagersOptionKey',
  editStatus: 'RequestProfile.RelatedRequestsEditStatusOptionKey',
  markAsRead: 'RequestProfile.RelatedRequestsMarkAsReadOptionKey',
  markAsUnread: 'RequestProfile.RelatedRequestsMarkAsUnreadOptionKey',
  removeAttach: 'RequestProfile.RelatedRequestsRemoveOptionKey',
  restore: 'RequestProfile.RelatedRequestsRestoreOptionKey',
}
